export default "__VITE_ASSET__DbCpfgmW__"